import React from 'react';

interface Props {
  id: string;
}

export const CarrierContracts = ({ id, }:Props) => {
  return (
    <div>
      Umowy { id}
    </div>
  );
};
